import React from "react";

import styles from "../../../styles/integrations.module.scss";

import { EnvironmentStorage } from "../../tools/EnvironmentStorage";
import { Loading } from "../../components/Loading";
import { Drawer } from "../../components/Drawer";
import { Input } from "../../components/Input";
import { Button } from "../../components/Button";
import { Context } from "pages/Integrations";
import { EnvironmentsAPI } from "providers/EnvironmentsAPI";
import { Label, Select } from "@components";
import { Toggle } from "shared/components/Toggle";

export default class EasyassistDrawer extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			loadingPage: true,
			loading: false,
			active: true,
			environment: "PRODUCTION",
			estabelecimento_id: null,
			formas_pagamento: {
				ONLINE_CREDIT: null,
				ONLINE_PIX: null,
				ONLINE_VOUCHER: null,
				LOCAL_CREDIT: null,
				LOCAL_DEBIT: null,
				LOCAL_VOUCHER: null,
				LOCAL_MONEY: null,
			}
		};
	}

	componentDidMount() {
		this.loadConfigs();
	}

	async loadConfigs() {
		const environmentId = EnvironmentStorage.getEnvironment().id;

		const externalCredentials = await EnvironmentsAPI.getConfigurationsByAlias(
			environmentId,
			"external_credentials"
		);
		const configs = externalCredentials.easyassist || {};

		if (Object.keys(configs).length > 0) {
			this.setState({
				active: configs?.active || false,
				environment: configs?.environment || "SANDBOX",
				estabelecimento_id: configs?.estabelecimento_id,
				formas_pagamento: {
					ONLINE_CREDIT: configs?.formas_pagamento?.ONLINE_CREDIT,
					ONLINE_PIX: configs?.formas_pagamento?.ONLINE_PIX,
					ONLINE_VOUCHER: configs?.formas_pagamento?.ONLINE_VOUCHER,
					LOCAL_CREDIT: configs?.formas_pagamento?.LOCAL_CREDIT,
					LOCAL_DEBIT: configs?.formas_pagamento?.LOCAL_DEBIT,
					LOCAL_VOUCHER: configs?.formas_pagamento?.LOCAL_VOUCHER,
					LOCAL_MONEY: configs?.formas_pagamento?.LOCAL_MONEY,
				}
			});
		}

		this.setState({ loadingPage: false });
	}

	async onSave() {
		try {
			const { onSave } = this.props;
			const { active, environment, estabelecimento_id, formas_pagamento } = this.state;

			this.setState({ loading: true });

			const environmentId = EnvironmentStorage.getEnvironment().id;

			const externalCredentials = await EnvironmentsAPI.getConfigurationsByAlias(
				environmentId,
				"external_credentials"
			);

			const updateResponse = await EnvironmentsAPI.putConfigurationsByAlias(
				environmentId,
				"external_credentials",
				{
					...externalCredentials,
					easyassist: {
						active,
						environment,
						estabelecimento_id,
						formas_pagamento
					},
				}
			);

			this.setState({ loading: false });

			if (updateResponse.getErrors([]).length === 0) {
				onSave && onSave();
			} else {
				alert({
					text: `Não foi possível alterar a configuração: ${updateResponse.getErrors()[0]}`,
				});
			}
		} catch (e) {
			this.setState({ loading: false });
		}
	}

	setFormaPagamento(alias, value) {
		this.setState({
			...this.state,
			formas_pagamento: {
				...this.state.formas_pagamento,
				[alias]: value
			}
		})
	}

	render() {
		const { loading, loadingPage, active, environment, estabelecimento_id, formas_pagamento } = this.state;
		const { visible, onClose } = this.props;

		const isValid = environment && estabelecimento_id;

		return (
			<Drawer
				visible={visible}
				onClose={onClose}
				closeInFade
				title={"Easyassist"}
				footer={
					<Button
						design="primary"
						className="w-100"
						onClick={() => this.onSave()}
						loading={loading}
						disabled={loading || !isValid}
					>
						Salvar alterações
					</Button>
				}
			>
				<Context />

				{loadingPage ? (
					<div className="d-flex justify-center align-center h-100">
						<Loading fullScreen />
					</div>
				) : (
					<div className={styles.scrollContainer}>
						<div className={styles.toggle}>
							<div className="d-flex justify-end w-100">
								<Toggle
									active={active}
									onChange={(active) => this.setState({ active })}
								/>
							</div>
						</div>

						<Select
							design="two"
							label="Ambiente"
							onChange={(e) => this.setState({ environment: e.target.value })}
							className="mb-20"
							value={environment}
							options={[
								{
									label: "Produção",
									value: "PRODUCTION",
									selected: environment === "PRODUCTION",
								},
								{
									label: "Homologação",
									value: "SANDBOX",
									selected: environment === "SANDBOX",
								},
							]}
						/>
						<Input
							design="two"
							className="mb-20"
							floatLabel="Código do estabelecimento"
							value={estabelecimento_id}
							onChange={(e) => this.setState({ estabelecimento_id: e.target.value })}
						/>

						<Label>Formas de pagamento</Label>
						<Input
							design="two"
							className="mb-20"
							floatLabel="Crédito online (Olga)"
							value={formas_pagamento?.ONLINE_CREDIT}
							onChange={(e) => this.setFormaPagamento("ONLINE_CREDIT", e.target.value)}
						/>
						<Input
							design="two"
							className="mb-20"
							floatLabel="Voucher online (Olga)"
							value={formas_pagamento?.ONLINE_VOUCHER}
							onChange={(e) => this.setFormaPagamento("ONLINE_VOUCHER", e.target.value)}
						/>
						<Input
							design="two"
							className="mb-20"
							floatLabel="Pix online (Olga)"
							value={formas_pagamento?.ONLINE_PIX}
							onChange={(e) => this.setFormaPagamento("ONLINE_PIX", e.target.value)}
						/>
						<Input
							design="two"
							className="mb-20"
							floatLabel="Crédito (Entrega)"
							value={formas_pagamento?.LOCAL_CREDIT}
							onChange={(e) => this.setFormaPagamento("LOCAL_CREDIT", e.target.value)}
						/>
						<Input
							design="two"
							className="mb-20"
							floatLabel="Débito (Entrega)"
							value={formas_pagamento?.LOCAL_DEBIT}
							onChange={(e) => this.setFormaPagamento("LOCAL_DEBIT", e.target.value)}
						/>
						<Input
							design="two"
							className="mb-20"
							floatLabel="Voucher (Entrega)"
							value={formas_pagamento?.LOCAL_VOUCHER}
							onChange={(e) => this.setFormaPagamento("LOCAL_VOUCHER", e.target.value)}
						/>
						<Input
							design="two"
							className="mb-20"
							floatLabel="Dinheiro (Entrega)"
							value={formas_pagamento?.LOCAL_MONEY}
							onChange={(e) => this.setFormaPagamento("LOCAL_MONEY", e.target.value)}
						/>
					</div>
				)}
			</Drawer>
		);
	}
}
